<template>
  <AppSplitter
    :has-profiler.sync="hasProfiler"
    :is-email="isEmail"
  >
    <template #before>
      <AttendanceVoice
        v-if="isVoice"
        :key="attendanceId"
        :attendance-id="attendanceId"
        :tab="tab"
        @change-view="handleTab"
        :is-preview="isPreview"
      />

      <AttendanceChat
        v-if="isChat"
        :attendance-id="attendanceId"
        :tab="tab"
        @change-view="handleTab"
        :is-preview="isPreview"
      />

      <AttendanceMail
        @open-profiler="handleOpenSplitter"
        v-if="isEmail"
        :attendance-id="attendanceId"
        :is-preview="isPreview"
      />
    </template>

    <template #after>
      <Profiler
        @close-profiler="handleOpenSplitter"
        :is-email="isEmail"
        :attendance-id="attendanceId"
        :profiler-selected="profilerSelected"
        :is-preview="true"
      />
    </template>
  </AppSplitter>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { VOICE_CHANNEL, TEXT_CHANNEL, MAIL_CHANNEL } from '@/constants/channels'

import Profiler from '@/components/Profiler'
import AppSplitter from '@/components/AppSplitter'
import AttendanceChat from '@/components/AttendanceChat'
import AttendanceMail from '@/components/AttendanceMail'
import AttendanceVoice from '@/components/AttendanceVoice'

export default {
  components: {
    Profiler,
    AppSplitter,
    AttendanceMail,
    AttendanceChat,
    AttendanceVoice
  },

  props: {
    attendanceId: {},
    isPreview: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tab: 'current',
      openSplitter: false,
      profilerSelected: {}
    }
  },

  mounted () {
    if (this.checkProfiler && !this.isEmail) this.loadProfiler(this.attendanceId)
  },

  watch: {
    attendanceStatus: {
      deep: true,
      handler () {
        if (this.checkProfiler) this.loadProfiler(this.attendanceId)
      }
    }
  },

  methods: {
    ...mapActions({
      loadProfilerEmail: 'attendanceModule/loadProfilerEmail',
      loadProfiler: 'attendanceModule/loadProfiler',
      loadHistory: 'attendanceModule/loadHistory'
    }),

    handleTab (tabName) {
      this.tab = tabName
      if (tabName === 'history' && !this.attendance?.history) {
        this.loadHistory(this.attendance)
      }
    },

    handleOpenSplitter (isOpenClose, profilerSelected) {
      this.profilerSelected = profilerSelected
      this.openSplitter = isOpenClose
    }
  },

  computed: {
    ...mapState({
      attendance ({ attendanceModule }) {
        const attendanceId = this.attendanceId
        const { history, current } = attendanceModule
        return history[attendanceId] ?? current[attendanceId]
      },

      hasProfiler ({ attendanceModule }) {
        const vm = this
        if (vm.isEmail) return vm.openSplitter
        if (!vm.checkProfiler) return false

        const attendanceId = vm.attendanceId
        const isLoading = Boolean(attendanceModule.profilers[attendanceId]?.isLoading)
        if (isLoading) return true

        const profiler = attendanceModule.profilers[attendanceId]
        if (!profiler) return false

        const profilerTree = profiler?.tree ?? {}
        const profilerFields = Array.isArray(profiler?.fields) ? profiler?.fields : []
        return Boolean(profilerFields.length) || Boolean(profilerTree.children?.length)
      },

      isEmail () {
        return Boolean(this.profilerSelected.length)
      }
    }),

    checkProfiler () {
      return [VOICE_CHANNEL, TEXT_CHANNEL].includes(this.attendance?.channel)
    },

    checkLoadHistory () {
      return !this.attendance?.history && !this.isEmail
    },

    attendanceStatus () {
      return this.attendance?.status
    },

    isVoice () {
      return this.attendance?.channel === VOICE_CHANNEL
    },

    isChat () {
      return this.attendance?.channel === TEXT_CHANNEL
    },

    isEmail () {
      return this.attendance?.channel === MAIL_CHANNEL
    }
  }
}
</script>
